import React from 'react';
import { TextareaAutosize, FormControl } from '@material-ui/core';
import { useField } from 'formik';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core';
const styles = makeStyles((theme) => ({
    rootFormControl: (props) => ({
        direction: props.dynamic ? 'ltr' : 'inherit',
        textAlign: 'start',
        width: props.dynamic ? '100%' : props.width ? props.width : '336px'
    }),
    label: {
        paddingBottom: '8px',
        color: '#767676'
    },
    errorContainer: (props) => ({
        padding: '3px 7px',
        fontSize: '0.9em',
        color: 'red',
        minHeight: props.dynamic ? '0' : '26px'
    }),
    textarea: {
        border: '1px solid #bbbbbb',
        borderRadius: '6px',
        color: '#363636',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        padding: '5px 7px',
        minHeight: '40px',
        height: '100%',
        [theme.breakpoints.down(1025)]: {
            minHeight: '68px'
        },
        '&::-webkit-resizer': {
            display: 'none'
        },
        '&:focus': {
            border: 'solid 1px #1b90fa',
            outline: 'none'
        }
    }
}));
export default function AutosizeTextarea(props) {
    const { disabled } = props;
    const classes = styles(props);
    const [field, meta] = useField(props);
    return (
        <FormControl classes={{ root: classes.rootFormControl }}>
            {props.dynamic ? (
                <label
                    dangerouslySetInnerHTML={{ __html: props.label }}
                    className={classes.label}
                    htmlFor={props.id || props.name}
                ></label>
            ) : (
                <label className={classes.label} htmlFor={props.id || props.name} id={props.name}>
                    {props.label}
                </label>
            )}
            <TextareaAutosize
                className={classes.textarea}
                dir="auto"
                rowsMin={props.rows ? props.rows : 1}
                rowsMax={props.rowsMax || 5}
                autoComplete="bemiraam"
                aria-labelledby={props.name}
                data-testid={props.name}
                disabled={disabled}
                {...field}
                {...props}
            />

            <div className={classes.errorContainer}>
                {meta.touched && meta.error ? <span>{meta.error}</span> : null}
            </div>
        </FormControl>
    );
}
AutosizeTextarea.propTypes = {
    id: PropTypes.any,
    name: PropTypes.string,
    label: PropTypes.string,
    dynamic: PropTypes.any,
    rows: PropTypes.number,
    rowsMax: PropTypes.number,
    disabled: PropTypes.bool
};
